import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { useNumberFormatter } from "@opensea/i18n";
import { NumberDisplay, Tooltip } from "@opensea/ui-kit";
import { bn } from "@opensea/utils";
import { CurrencyPriceFragment } from "./CurrencyPrice.fragment";
export function CurrencyPriceDisplay(t0) {
  const $ = _c(13);
  const {
    value,
    custom: customProp,
    stableSignificantDigits: t1,
    withFullValueTooltip: t2
  } = t0;
  const stableSignificantDigits = t1 === undefined ? false : t1;
  const withFullValueTooltip = t2 === undefined ? true : t2;
  const format = useNumberFormatter();
  let t3;
  if ($[0] !== customProp || $[1] !== stableSignificantDigits || $[2] !== value) {
    t3 = stableSignificantDigits ? {
      ...getStableSignificantDigitsOptions(value),
      ...customProp
    } : customProp;
    $[0] = customProp;
    $[1] = stableSignificantDigits;
    $[2] = value;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const custom = t3;
  const formattedValue = format(value, {
    display: "usd-compact",
    custom
  });
  const fullValue = format(value, {
    display: "usd-full"
  });
  let t4;
  if ($[4] !== value) {
    t4 = <NumberDisplay display="usd-full" value={value} />;
    $[4] = value;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !withFullValueTooltip || formattedValue === fullValue;
  let t6;
  if ($[6] !== custom || $[7] !== value) {
    t6 = <NumberDisplay custom={custom} display="usd-compact" value={value} />;
    $[6] = custom;
    $[7] = value;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = <Tooltip content={t4} disabled={t5}>{t6}</Tooltip>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
function getStableSignificantDigitsOptions(value) {
  const isGreaterThanOne = value && bn(value).gt(1);
  const options = {
    roundingPriority: "lessPrecision"
  };
  if (isGreaterThanOne) {
    options.minimumSignificantDigits = 3;
    options.maximumFractionDigits = 2;
  } else {
    options.minimumSignificantDigits = 4;
  }
  return options;
}
export function CurrencyPrice(t0) {
  const $ = _c(8);
  let currencyKey;
  let rest;
  if ($[0] !== t0) {
    ({
      currency: currencyKey,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = currencyKey;
    $[2] = rest;
  } else {
    currencyKey = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== currencyKey) {
    t1 = readFragment(CurrencyPriceFragment, currencyKey);
    $[3] = currencyKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const currency = t1;
  const t2 = Number(currency.usdPrice);
  let t3;
  if ($[5] !== rest || $[6] !== t2) {
    t3 = <CurrencyPriceDisplay value={t2} {...rest} />;
    $[5] = rest;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}